import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ShareCapitalService {
  URl = this.ConfigService.getAPIBaseUrl() + 'api/ShareCapitalDetails'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  insertdetails(data: any) {
    return this.http.post(this.URl + '/InsertIShareCapital', data)
  }
  getdata(APPeriodId: any) {
    return this.http.get(this.URl + '/GetIShareCapital?APPeriodId=' + APPeriodId)
  }
  getdata_LY(APPeriodId: any) {
    return this.http.get(this.URl + '/GetIShareCapital_LY?APPeriodId=' + APPeriodId)
  }
} 
